import React, { useEffect, useState } from 'react';
import { useAuth } from '../hooks/contexts/AuthContext';

function ApiDispatch() {
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
    const { isLoggedIn } = useAuth();

    useEffect(() => {
        setTimeout(() => {
            if (isLoggedIn) {
                setIsUserLoggedIn(true);
            } else {
                setIsUserLoggedIn(false);
            }
        }, 800);
    }, [isLoggedIn]);

    return (
        <>
            {/* <MobileHomepageData />
            <AllProductsFetch />
            <BestSeller />
            <FeaturedProducts />
            <TopFiveProducts />
            <EntertainmentProducts />
            <SliderData />
            <ProductFilterByCategory />
            <Blog />
             */}
        </>
    );
}

export default ApiDispatch;
